'use strict';

/*@ngInject*/
module.exports = function ($scope, $translate, $timeout, platform, $location, $http, urlFormats, $rootScope, $stateParams, $window) {

    $scope.downloadArrow = '';
    /*$timeout(function () {*/

        if(($window.navigator.userAgent.indexOf('Trident') > -1 || $window.navigator.userAgent.indexOf('MSIE') > -1 || $window.navigator.userAgent.indexOf('Edge') > -1)){
            $scope.downloadArrow = 'images/download-arrow-ie.png';
            $scope.downloadModelIe = true;
            $scope.downloadDescContent = 'downloadPageModelScreen.descIe';
            $scope.downloadSubDescContent = 'downloadPageModelScreen.subDescIe';
        }
    else if($window.navigator.userAgent.indexOf('Chrome') > -1){
        $scope.downloadArrow = 'images/download-arrow-chrome.png';
        $scope.downloadModelChrome = true;
        $scope.downloadDescContent = 'downloadPageModelScreen.descChrome';
        $scope.downloadSubDescContent = 'downloadPageModelScreen.subDescChrome';
    }
        else if($window.navigator.userAgent.indexOf('Firefox') > -1){
            $scope.downloadArrow = 'images/download-arrow-firefox.png';
            $scope.downloadModelFirefox = true;
            $scope.downloadDescContent = 'downloadPageModelScreen.descFirefox';
        }
        else if($window.navigator.userAgent.indexOf('Safari') > -1){
            $scope.downloadArrow = 'images/download-arrow-firefox.png';
            $scope.downloadModelIe = true;
            $scope.downloadDescContent = 'downloadPageModelScreen.descSafari';
        }
    /*}, 2000);*/
    $timeout(function () {
        $scope.downloadModelFirefox = false;
        $scope.downloadModelIe = false;
        $scope.downloadModelChrome = false;
    }, 10000);
    /*if($window.navigator.userAgent.indexOf("Safari") > -1 ){
        $scope.downloadModelSafari = true;
    }*/
    $scope.modelclick = function modelclick(){
        if($window.navigator.userAgent.indexOf('Chrome') > -1){
            $scope.downloadModelChrome = $scope.downloadModelChrome ? !$scope.downloadModelChrome : $scope.downloadModelChrome;
        }
        if(($window.navigator.userAgent.indexOf('Trident') > -1 || $window.navigator.userAgent.indexOf('MSIE') > -1 || $window.navigator.userAgent.indexOf('Edge') > -1)){
            $scope.downloadModelIe = $scope.downloadModelIe ? !$scope.downloadModelIe : $scope.downloadModelIe;
        }
        if($window.navigator.userAgent.indexOf('Firefox') > -1){
            $scope.downloadModelFirefox = $scope.downloadModelFirefox ? !$scope.downloadModelFirefox : $scope.downloadModelFirefox;
        }
    };

    if ($scope.searchData) {       
        $scope.androidDownloadLink = urlFormats.android.googlePlay + $scope.searchData;
        $scope.iosDownloadLink = urlFormats.ios.appStore + $scope.searchData;
        $scope.windowDownloadLink = urlFormats.windows.windowsStore+ "?name=SafeFamilySetup_"  + $scope.searchData+".exe";
    } else {      
        $scope.androidDownloadLink = urlFormats.android.googleDefault;
        $scope.iosDownloadLink = urlFormats.ios.appstoreDefault;
        $scope.windowDownloadLink = urlFormats.windows.windowsDefault;
    }
 
    $scope.createDynamicURL = createDynamicURL;

    function createDynamicURL(){
       window.location.href = $scope.windowDownloadLink;
    }


    $scope.gaFunction = function(labelValue){
        //window.ga('send', 'event','Onboarding', 'Windows Download - Landing page',labelValue,'download_landing_page', 'Lifecycle');
        /*window.ga('send', 'event', {
            eventCategory: 'Onboarding',
            eventAction: 'Windows Download - Landing page',
            eventLabel: labelValue,
           'dimension1': 'download_landing_page',
            'dimension2': 'Lifecycle',
            'dimension6': 'true',
            'dimension4': 'true'
        });*/
        IntelSecurity.Analytics.Api.Track
            .event('download_landing_page')
            .feature("Lifecycle")
            .category("Onboarding")
            .action('Windows Download - Landing page')
            .label(labelValue)
            .interactive(true)
            .userInitiated(true)
            .finish();
    };
    if (platform.os && platform.os.family) {
        $scope.isWindows = platform.os.family.toLowerCase().indexOf('win') >= 0;
        $scope.isIos = platform.os.family.toLowerCase().indexOf('ios') >= 0;
        if ($scope.isWindows === true) {
            //Here your view content is fully loaded !!

                $timeout(function () {
                    console.log("Came Here");
                    window.location.href = $scope.windowDownloadLink;
                }, 2000);
        }
        return false;
    }
};